import { ReturoReportPayload } from 'components/shop-reception/mobile/interfaces'

export const toReportPayload = (noticeStatus: string, values: ReturoReportPayload) => ({
  ...values,
  noticeStatus
})
